// Libraries

var React = require('react');
var Hls = require('hls.js');
var debounce = require('lodash/debounce');

// Styles

require('./VideoEmbedStream.scss');

// Assets

var videoIcon = require('./play.svg');

var EndeavorVideoChromecast = require('./EndeavorVideoChromecast.js');

class VideoEmbedStream extends React.Component {

	constructor(props) {

		super(props);
		this.videoPlayer = React.createRef();
		this.adsContainer = React.createRef();
		this.chromecastChild = React.createRef();
		this.playButton = React.createRef();

		this.adsDisplayContainer = null;
		this.adsLoader = null;
		this.adsManager = null;
		this.adsRequest = null;
		this.hasAds = (this.props.entryId && this.props.entryId !== '');
		this.allowAds = false;

        this.state = {
			tickInterval: null,
			defaultMParticleEventObject: window.defaultMParticleEventObject,
			eventData: null,
			allowVideoEventPush: true,
			lastVideoEventNamePushed: '',
			lastVideoEventActionTypePushed: '',
            videoDetails: null,
            hasErrored: false,
			hasStarted: false,
			showChromecast: false,
			adsLoaded: false,
			adsPaused: false,
			adsFinished: false,
			adsErrored: false
		};

	}

	componentDidMount() {

		if (!this.hasAds) {

			this.loadVideo();
			return;

		}

		let checkAlertBoxClosedAndValidInterval = setInterval(() => {

			let oneTrustValid = window['OneTrust'] && window['OneTrust'].IsAlertBoxClosedAndValid();

			if (
				window['alertBoxIsClosedAndValid'] ||
				oneTrustValid
			) {

				clearInterval(checkAlertBoxClosedAndValidInterval);
				this.setAdsAllowed();

				if (!this.allowAds) {

					this.loadVideo();
					return;

				}

				this.injectPreRollDependencies();

				let checkImaSdkLoadedInterval = setInterval(() => {

					if (window['imaSdkLoaded']) {

						clearInterval(checkImaSdkLoadedInterval);
						this.loadVideo();

					}

				}, 50);

			}

		}, 50);

	}

	loadVideo() {

		this.requestVideoDetails().then(json => {

			var videoSrc = json.hlsUrl;

			this.setState({
				videoDetails: json,
				showChromecast: typeof window.chrome !== "undefined"
			});

			this.videoPlayer.current.setAttribute('poster', json.thumbnailUrl);

			if (Hls.isSupported()) {

				var hls = new Hls();
				hls.loadSource(videoSrc);
				hls.attachMedia(this.videoPlayer.current);

			} else if (this.videoPlayer.current.canPlayType('application/vnd.apple.mpegurl')) {

				this.videoPlayer.current.src = videoSrc;

			}

			this.attachVideoEvents();

		}).catch((e)=> {

			this.setState({ hasErrored: true });

		})

	}

	injectPreRollDependencies() {

		if (typeof window === 'undefined') return;
		if (typeof window['imaSdkLoaded'] !== 'undefined') return;

		var imaSdkLoadedScript = document.createElement('script');
		imaSdkLoadedScript.appendChild(document.createTextNode('var imaSdkLoaded = false;')); 
		document.body.appendChild(imaSdkLoadedScript);

		const imaSdkScript = document.createElement('script');
		imaSdkScript.src = '//imasdk.googleapis.com/js/sdkloader/ima3.js';
		imaSdkScript.onload = function() { window['imaSdkLoaded'] = true; };
		document.body.appendChild(imaSdkScript);

	}

	requestVideoDetails() {

		return fetch("/api/v1/endeavorvideo/" + this.props.entryId).then( response => {

			if (this.props.exampleResponse) return this.props.exampleResponse; // this makes static frontend work
			if (!response.ok) { throw response }
			return response.json();

		});

	}

	getPublishedDateForTracking() {

		if (this.props.publishedDate) return this.props.publishedDate.slice(0,10);

		const dateObj = new Date();
		const month = dateObj.getUTCMonth() + 1;
		const day = dateObj.getUTCDate();
		const year = dateObj.getUTCFullYear();
		return year + "-" + month + "-" + day;

	}

	setAdsAllowed() {

		if (
			window['OnetrustActiveGroups'] === "undefined" ||
			window['OneTrust'] === "undefined" ||
			window['OneTrust']['GetDomainData'] === "undefined"
		) {

			return;

		}

		const domainData = window['OneTrust'].GetDomainData();

		if (
			domainData.Groups === "undefined" ||
			!domainData.Groups.length
		) {

			return;

		}

		let requiredGroups = [];

		for (var i = 0; i < domainData.Groups.length; i++) {
			(function (i) {

				requiredGroups.push(domainData.Groups[i].OptanonGroupId);

			}).call(this, i);
		}

		if (!requiredGroups.length) {

			//console.log('No required cookie category groups for pre-rolls, therefore not showing pre-rolls.');
			return;

		}

		if (!requiredGroups.includes('C0004')) {
			
			//console.log('Manually populated cookie category of targeting (C0004) as a required group for pre-rolls.  Pre-rolls may not work.');
			requiredGroups.push('C0004');
		
		}

		if (window.location.host !== 'www.tottenhamhotspur.com') {

			//console.log('Manually excluding cookie category social media (C0005) as a required group for pre-rolls because a non-prod url was detected.');

			const socialGroupIndex = requiredGroups.indexOf('C0005');
			if (socialGroupIndex > -1) { requiredGroups.splice(socialGroupIndex, 1); }

		}

		const activeGroups = window['OnetrustActiveGroups'].split(',');
		let allRequiredGroupsActive = true;

		for (var i = 0; i < requiredGroups.length; i++) {
			(function (i) {

				if (!activeGroups.includes(requiredGroups[i])) {

					allRequiredGroupsActive = false;

				}

			}).call(this, i);
		}

		this.allowAds = allRequiredGroupsActive;

	}

	initializeIMA() {

		this.adsDisplayContainer = new window['google'].ima.AdDisplayContainer(this.adsContainer.current, this.videoPlayer.current);
		this.adsLoader = new window['google'].ima.AdsLoader(this.adsDisplayContainer);

		this.adsLoader.addEventListener(window['google'].ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (adsManagerLoadedEvent) => {

			const adsRenderingSettings = new window['google'].ima.AdsRenderingSettings();
  			adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;

			this.adsManager = adsManagerLoadedEvent.getAdsManager(this.videoPlayer.current, adsRenderingSettings);

			this.adsManager.addEventListener(window['google'].ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, () => {

				this.setState({ adsFinished: true });
				this.videoPlayer.current.play();

			});

			this.adsManager.addEventListener(window['google'].ima.AdEvent.Type.PAUSED, () => {

				this.setState({ adsPaused: true });

			});

			window.addEventListener('resize', debounce(() => {

				if (this.adsManager) {

					this.adsManager.resize(this.videoPlayer.current.clientWidth, this.videoPlayer.current.clientHeight, window['google'].ima.ViewMode.NORMAL);
				  
				}

			}, 500));

		}, false);

		this.adsLoader.addEventListener(window['google'].ima.AdErrorEvent.Type.AD_ERROR, (adsManagerLoadedEvent) => {

			this.setState({ adsErrored: true });

		}, false);

		this.adsRequest = new window['google'].ima.AdsRequest();

		const entryId = this.props.entryId;
		const contentTags = this.props.contentTags && this.props.contentTags !== '' ? encodeURIComponent(this.props.contentTags) : '';
		const entryUrl = this.props.videoPublicUrl && this.props.videoPublicUrl !== '' ? encodeURIComponent(this.props.videoPublicUrl) : encodeURIComponent(window.location.href);

		//const exampleAdTagUrl = `https://pubads.g.doubleclick.net/gampad/ads?iu=/${entryId}/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`;
		const adTagUrl = `https://pubads.g.doubleclick.net/gampad/ads?iu=/424488768/spurs_web_preroll&description_url=${entryUrl}&tfcd=0&npa=0&sz=400x300%7C640x480&cust_params=content_tag%3D${contentTags}%26vid_id%3D${entryId}&gdfp_req=1&output=vast&env=vp&unviewed_position_start=1&impl=s&correlator=&nofb=`;

		// console.log({entryUrl, entryId, contentTags});
		// console.log('---- All props ----');
		// console.log(this.props);
		// console.log('---- All props ----');

		this.adsRequest.adTagUrl = adTagUrl;

		this.adsRequest.linearAdSlotWidth = this.videoPlayer.current.clientWidth;
		this.adsRequest.linearAdSlotHeight = this.videoPlayer.current.clientHeight;
		this.adsRequest.nonLinearAdSlotWidth = this.videoPlayer.current.clientWidth;
		this.adsRequest.nonLinearAdSlotHeight = this.videoPlayer.current.clientHeight / 3;
		
		this.adsLoader.requestAds(this.adsRequest);

	}

	loadAds() {

		if (this.state.adsLoaded) return;
		this.setState({ adsLoaded: true });

		this.adsDisplayContainer.initialize();

		if (this.state.adsErrored) {

			this.setState({ adsFinished: true, adsLoaded: true });
			this.videoPlayer.current.play();
			return;

		}

		try {

			this.adsManager.init(this.videoPlayer.current.clientWidth, this.videoPlayer.current.clientHeight, window['google'].ima.ViewMode.NORMAL);
			this.adsManager.start();

		} catch (adError) {

			console.log("AdsManager could not be started");
			console.log(adError);
			this.setState({ adsFinished: true, adsLoaded: true });
			this.videoPlayer.current.play();

		}

	}

    attachVideoEvents() {

		if (this.allowAds) this.initializeIMA();

        let seekedCount = 0;
        let eventData;

		this.videoPlayer.current.addEventListener('load', () => {

			if (this.videoPlayer.current.textTracks.length) {

				const firstTrack = this.videoPlayer.current.textTracks[0];
				firstTrack.mode = 'showing';

			}

		});

        this.videoPlayer.current.addEventListener('canplay', () => {

			if(!this.state.hasStarted) {

				eventData = {
					content_access_type: 'free',
					content_id: this.state.videoDetails.id,
					content_type: 'video',
					content_tags: this.parseTags(this.state.videoDetails.tags),
					content_title: this.state.videoDetails.name,
					content_publication_date: this.getPublishedDateForTracking(),
					content_duration: this.state.videoDetails.duration,
					video_stream_type: "on_demand",
					interval_sec: 10
				};

				this.setState({eventData: eventData, hasStarted: true});

				this.pushToDataLayerContentSelect(eventData);
				
			} 

        });

        this.videoPlayer.current.addEventListener('play', (event) => {

            this.pushToDataLayer(eventData, 'video_played', 'manual');

            clearInterval(this.state.tickInterval);

            let intervalId = setInterval(() => {

                if (this.videoPlayer.current) {
                
                    this.pushToDataLayer(eventData, 'video_play_ticked', 'auto');
                
                }

            }, 10000);
            
            this.setState({tickInterval: intervalId});

        });

        this.videoPlayer.current.addEventListener('pause', () => {

			if(this.videoPlayer.current.readyState === 4 && this.videoPlayer.current.currentTime !== this.videoPlayer.current.duration && !this.videoPlayer.current.seeking) {
				this.pushToDataLayer(eventData, 'video_paused', 'manual');
				clearInterval(this.state.tickInterval);
			}

        });

        this.videoPlayer.current.addEventListener('ended', () => {

				this.pushToDataLayer(eventData, 'video_ended', 'auto');

				clearInterval(this.state.tickInterval);

        });

        this.videoPlayer.current.addEventListener('seeked', () => {
            
            if (seekedCount > 0) { clearInterval(this.state.tickInterval); }
            seekedCount++;

        });

    }

    componentWillUnmount() {

        clearInterval(this.state.tickInterval);

		this.setState({ tickInterval: null });
		
		if (this.videoPlayer.current) {

			const eventData = this.state.eventData;
			this.pushToDataLayer(eventData, 'video_ended', 'manual');

			this.setState({ eventData: null });

			if(this.chromecastChild.current) {
				this.chromecastChild.current.stopApp();
			}

		}

	}

	parseTags(tags) {

		if (!tags.length) return null;

		return tags.join('|');

	}

	determineIfDuplicateEvent(eventName, actionType) {

		if (eventName === 'video_play_ticked') {

			return false;

		}

		return (this.state.lastVideoEventNamePushed === eventName) && (this.state.lastVideoEventActionTypePushed === actionType);

	}

    pushToDataLayer(defaultData, eventName, actionType) {

		// Catch dupe 'video_play_ticked' events using timeout and bin them off
		// They are able to fire in succession so can't be caught by the function 'determineIfDuplicateEvent'

		if (eventName === 'video_play_ticked' && !this.state.allowVideoEventPush) { 

			return false;

		}

		// Catch other dupe events using function 'determineIfDuplicateEvent' and bin them off

		const isDupe = this.determineIfDuplicateEvent(eventName, actionType);

		if (isDupe) {

			return false;

		}

		this.setState({
			allowVideoEventPush: false,
			lastVideoEventNamePushed: eventName,
			lastVideoEventActionTypePushed: actionType
		});

		let eventData = defaultData;

		eventData.event = eventName;
		eventData.action_type = actionType;

		const eventDataMerged = {...this.state.defaultMParticleEventObject, ...eventData };
		window.dataLayer.push(eventDataMerged);

		setTimeout(() => {

			this.setState({allowVideoEventPush: true});

		}, 500);

	}

    pushToDataLayerContentSelect(eventData) {

		let placementName = 'other';

		if (this.videoPlayer.current) {

			const placementNameTarget = this.videoPlayer.current.closest('[data-placement-name]');
			placementName = placementNameTarget ? placementNameTarget.getAttribute('data-placement-name') : placementName;

		}

		eventData.event = 'content_selected';
		eventData.placement_type = 'list';
		eventData.placement_name = placementName;

		const eventDataMerged = {...this.state.defaultMParticleEventObject, ...eventData };
		window.dataLayer.push(eventDataMerged);

	}

	handleCasting() {

		this.videoPlayer.current.pause();
		this.videoPlayer.current.removeAttribute("controls");

	}

	handleStopCasting(lastChromecastTime) {

		const videoPlayerElement = this.videoPlayer.current;

		if(videoPlayerElement) {

			videoPlayerElement.setAttribute("controls", "controls");
			videoPlayerElement.pause();
			videoPlayerElement.currentTime = lastChromecastTime;

		}
	}

	handlePlayButtonClick() {

		if (
			this.state.adsLoaded &&
			this.state.adsPaused
		) {
		
			this.setState({ adsPaused: false });
			this.adsManager.resume();
			return;

		}

		this.loadAds();

	}

	getVideoPlayer() {

		return this.videoPlayer.current;

	}


    render() {

        if (this.state.hasErrored) {

            return (
                <div className="VideoEmbedStream">
                    <p role="alert" className="VideoEmbedStream__error">An error has occurred. Please try again later.</p>
                </div>
            )

        }

		const hasSubs = this.state.videoDetails && this.state.videoDetails.subtitles;
		const showSubs = this.allowAds ? (hasSubs && this.state.adsFinished) : hasSubs;
		const showControls = this.allowAds ? (this.state.adsFinished ? true : null) : true;
		const autoPlayVideo = this.allowAds ? false : this.props.autoplay;

		return (
			<div className={`VideoEmbedStream${this.state.adsLoaded ? " VideoEmbedStream--ads-loaded" : ""}${this.state.adsFinished ? " VideoEmbedStream--ads-finished" : ""}${this.state.adsPaused ? " VideoEmbedStream--ads-paused" : ""}`}>
				{
					this.state.videoDetails ?
						<video id="video" controls={showControls} playsInline ref={this.videoPlayer} crossOrigin="anonymous" autoPlay={autoPlayVideo} muted={autoPlayVideo}>
							{showSubs && this.state.videoDetails.subtitles.map(function (subtitle, index) {
									return (<track label={subtitle.lang} kind="captions" srcLang={subtitle.lang} src={subtitle.url} default={index === 0} key={index} />);
								})
							}
						</video>
					: null
				}	
				
				{this.state.videoDetails && this.state.showChromecast ?
					<EndeavorVideoChromecast ref={this.chromecastChild} requestVideoDetails={this.requestVideoDetails.bind(this)} handleCasting={this.handleCasting.bind(this)} handleStopCasting={this.handleStopCasting.bind(this)} getVideoPlayer={this.getVideoPlayer.bind(this)} />
				: null}
				{this.allowAds && !this.state.adsErrored ?
					<div className="VideoEmbedStream__advert-container" ref={this.adsContainer}></div>
				: null}
				{(this.allowAds && this.adsManager) || this.state.adsErrored ?
					<button className="VideoEmbedStream__play-button" onClick={this.handlePlayButtonClick.bind(this)}>
						<span className="u-visually-hidden">Play video</span>
						<span className="VideoEmbedStream__play-button-icon">
							<img src={videoIcon} alt="" />
						</span>
					</button>
				: null}
				{(this.allowAds && !this.adsManager && !this.state.adsErrored) ?
					<div className="c-loading-wrapper c-loading-wrapper--loading c-loading-wrapper--on-black">
						<span className="u-visually-hidden">Loading video</span>
					</div>
				: null}
			</div>
		)
	}


}

module.exports = VideoEmbedStream;


// WEBPACK FOOTER //
// ./src/components/Video/EndeavorVideoEmbedStream.js